import { IonRow, IonCol, IonGrid } from "@ionic/react";
import React from "react";
import { PickUpdate, Origin } from "../../../utils/constants";
import { NewInput } from "../common/OriginInput";
import { RadiusRange } from "../RadiusRange/RadiusRange";

const PickupLocation = (props: any) => {
  const {
    originError,
    origin,
    originCountry,
    originPostalCode,
    originRadius,
    isDestination,
    defaultValue,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
  } = props;
  const upDateLocalTime = (time: string) => {
    updateLocalCurrentTime(PickUpdate, time);
  };
  return (
    <IonGrid className="pickup-location-grid">
      <IonRow className="pickup-location-row">
        <IonCol className="pickup-location-col">
          <NewInput
            Error={originError}
            labelValue=""
            InputValue={origin}
            InputName={Origin}
            handleChange={(e: any) => props.handleChange(e)}
            isDestination={isDestination}
            deFaultValue={defaultValue}
            locationValue={false}
            useHandler={useHandler}
            setErrorValue={setErrorValue}
            placeholder="Select City"
            getLocalTime={upDateLocalTime}
            onFocus={props.onFocus || (() => {})}
            country={originCountry}
            postalCode={originPostalCode}
          />
        </IonCol>
      </IonRow>
      <IonRow className="pickup-location-row">
        <IonCol className="pickup-location-col">
          <RadiusRange
            labelName="Origin Radius"
            rangeDisabled={props.rangeOriginDisable}
            InputValue={originRadius}
            className="pickRadius"
            name={"originRadius"}
            handleChange={props.handleChange}
          />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
export default PickupLocation;
